define(function (require) {
    // general
    const ViewBindingManager = require('civicsUtils/view_binding_manager');
    // collections
    const AutoCompleteModel = require('civicsCollections/core/autocomplete_collection');
    const AutoCompleteMDModel = require('civicsCollections/core/autocomplete_md_collection');
    const IpsModel = require('civicsBase/ipsModel');

    const _autoComplete = function (options) {
        // set default options
        if (!options) options = {}
        const { inputNameAttr, isComposite, compMoniker, layerList, searchFailCallback } = options;
        // Resets object to empty value
        const resetObject = function (o) {
            for (var prop in o) {
                if (o.hasOwnProperty(prop)) {
                    if (!_.isArray(o[prop]) && _.isObject(o[prop]))
                        resetObject(o[prop]);
                    else 
                        o[prop] = '';
                }
            }
        };
        // Convert Meta Custom Display to LodashTemplate
        const convertBackOfficeToLodashTemplate = function (text) {
            var output = text;
            var regex = new RegExp(/\{([^}]+)\}/g);
            var myArray;
            while ((myArray = regex.exec(text)) != null) {
                // props with "." needs to be converted to "_" to work with _.template
                let dataDisplay = myArray[1].includes('.') ? myArray[1].replace('.', '_') : myArray[1];
                output = output.replace(new RegExp('{' + myArray[1] + '}', 'g'), '<%=' + dataDisplay + '%>');
            }
            return output;
        };
        // Find Jquery Input DOM Elements by name
        const findInputs = function (containers, inputName) {
            return containers.map(container => {
                let ctnr = container.$el ? container.$el : container;
                $input = ctnr.find("input[name='" + inputName + "'], textarea[name='" + inputName + "']");
                return {
                    $input: $input,
                    container: ctnr
                };
            });
        }
        // Build AutoComplete Settings based on Metadata and Options in this instance
        const buildAutoCompleteSettings = function (md) {
            // Place Composite Display Settings here
            compositeDisplaySettings = null;

            // Default Display Template
            var display = md.customDisplay && md.customDisplay.length > 0 ? md.customDisplay : '{' + md.property + '}';
            //convert ac template into lodash template
            display = convertBackOfficeToLodashTemplate(display);
            var displayTemplate = _.template(display);

            if (isComposite && _.isArray(md.joins) && layerList) {
                // Create initial Composite Display Settings that will be used by CivicsAutoComplete Renderer.
                // This settings will be used in Composite Cases.
                compositeDisplaySettings = {
                    totalMatches: 0,
                    totalResults: 0,
                    displayTemplates: {},
                    components: [],
                    layerList: layerList,
                    getLayerListUrlParams: function () {
                        let types = [];
                        let assets = [];
                        let urlParamExtension = {};
                        if (this.layerList) {
                            this.layerList.forEach(type => {
                                if (!types.includes(type.ipsComponentType))
                                    types.push(type.ipsComponentType);
                                if (type.assetType)
                                    assets.push(type.assetType);
                            })
                        }
                        if (types.length > 0)
                            _.extend(urlParamExtension, { 'MonikerName': `${types.join(',')}` });
                        if (assets.length > 0)
                            _.extend(urlParamExtension, { 'AssetType.AssetType': `${assets.join(',')}` });
                        return urlParamExtension;
                    },
                    // If there will be another composite component like asset that can have many types/children, 
                    // it should be added in this array. 
                    // type: 				This is composite component type.
                    // groupKey: 			This will determine the "type" of the child of the parent component. 
                    //						The value will be property name (Case-Sensitive) of the Auto Complete response.
                    // descriptionSource: 	This will determine the "type description" of the child. 
                    // 						The value will be property name (Case-Sensitive) of the Auto Complete response.
                    componentsWithChildren: [
                        {
                            type: 'hansen.assetmanagement.asset',
                            groupKey: 'AssetType.AssetType',
                            descriptionSource: 'AssetType'
                        }
                    ],
                    labelShowAll: i18n.t('CIVICS.COMMON.AUTO_COMPLETE_COMPOSITE_SHOWALL'),
                    labelShowSome: (results, matches) => {
                        return i18n.t('CIVICS.COMMON.AUTO_COMPLETE_COMPOSITE_SHOWSOME', { totalResults: results, totalMatches: matches });
                    }
                };

                // Build Composite Display Templates and update Composite Display Settings
                md.joins.forEach(component => {
                    // Get the layer type that matches to the metadata
                    let typeObj = layerList.find(type =>
                        type.ipsComponentType.toLowerCase() == component.bindMoniker.toLowerCase());

                    if (typeObj) {
                        // Set Display templates per IPS Component Type
                        let display = component.customDisplay ? component.customDisplay
                            : `{${component.property}}`;
                        display = convertBackOfficeToLodashTemplate(display);
                        let displayTemplate = _.template(display);
                        compositeDisplaySettings.displayTemplates[typeObj.ipsComponentType.toLowerCase()] = displayTemplate;

                        let bindMonikerStrings = component.bindMoniker.split('.');
                        let typeName = bindMonikerStrings && bindMonikerStrings.length > 0
                            ? bindMonikerStrings[bindMonikerStrings.length - 1]
                            : component.bindMoniker;
                        let componentDescription = typeName;
                        // If it's not composite component with children like Address/Parcel, then use localisation.
                        if (!compositeDisplaySettings.componentsWithChildren.map(component => component.type).includes(typeObj.ipsComponentType)) {
                            componentDescription = i18n.t(`CIVICS.COMMON.AUTO_COMPLETE_COMPOSITE_${typeName.toUpperCase()}`)
                        }
                        compositeDisplaySettings.components.push({
                            type: typeObj.ipsComponentType,
                            description: componentDescription
                        })
                    }
                });
            }

            var setting = {
                property: md.property,
                filterMode: 'none',
                compositeDisplaySettings: compositeDisplaySettings,
                source: function (request, response) {
                    var acService = new AutoCompleteModel();
                    acService.moniker = compMoniker;
                    acService.property = md.property;
                    acService.term = request;
                    if (options) {
                        if (compositeDisplaySettings) {
                            // Build Composite URL Parameters 
                            _.extend(options.urlParameters,
                                compositeDisplaySettings.getLayerListUrlParams());
                        }
                        acService.parameters = options.urlParameters;
                    }
                    acService.fetch()
                        .done((jResponse, f, g) => {
                            var list = [];

                            if (compositeDisplaySettings) {
                                compositeDisplaySettings.totalMatches = jResponse.totalMatches;
                                compositeDisplaySettings.totalResults = jResponse.documents.length;
                            }

                            if (jResponse.documents && jResponse.documents.length > 0) {
                                _.forEach(jResponse.documents, item => {
                                    var acListItem = {};
                                    if (compositeDisplaySettings && item.entries.MonikerName) {
                                        acListItem.label = compositeDisplaySettings
                                            .displayTemplates[item.entries.MonikerName.toLowerCase()](item.entries);
                                    }
                                    else {
                                        acListItem.label = displayTemplate(item.entries);
                                    }
                                    var model = _.clone(item.entries, true);
                                    acListItem.model = model;
                                    acListItem.delegates = item.delegates;
                                    if (options == null || options.excludeItemCallback == null
                                        || !options.excludeItemCallback(item)) {
                                        list.push(acListItem);
                                    }
                                });
                            }
                            response(request, list);
                        })
                        .fail((x, y, z) => {
                            if (searchFailCallback)
                                searchFailCallback(i18n.t('CIVICS.COMMON.AUTO_COMPLETE_ERROR'));
                        });
                }
            };
            if (_.has(md, 'minCharacters')) {
                _.extend(setting, { minLength: md.minCharacters });
            }

            if (_.has(md, 'mappings') && !_.isEmpty(md.mappings)) {
                _.extend(setting, { mappings: md.mappings });
            }

            return setting;
        }
        // Attach Off Event Handlers to the Input
        const attachInputEventHandlers = function (input) {
            input.$input.off('selected').on('selected', (x, y, acListItem) => {
                var m = new IpsModel();
                m.set(acListItem.model);
                ViewBindingManager.bindView(input.container, m);

                if (acListItem.delegates && acListItem.delegates.length > 0) {
                    _.forEach(acListItem.delegates, d => {
                        if (d.moniker && d.property && d.search) {
                            var delegatecService = new AutoCompleteModel();
                            delegatecService.moniker = d.moniker;
                            delegatecService.property = d.property;
                            delegatecService.term = d.search;
                            delegatecService.fetch()
                                .done((jResponse, f, g) => {
                                    if (jResponse.documents && jResponse.documents.length > 0) {
                                        _.forEach(jResponse.documents, item => {

                                            var clearObject = _.clone(item.entries, true);
                                            var clearModel = new IpsModel();
                                            resetObject(clearObject);
                                            clearModel.set(clearObject);
                                            ViewBindingManager.bindView(input.container, clearModel);

                                            var m = new IpsModel();
                                            m.set(item.entries);
                                            ViewBindingManager.bindView(input.container, m);
                                            if (options && options.selectedCallback) {
                                                options.selectedCallback(item.entries, acListItem);
                                            }
                                        });
                                    }
                                })
                                .fail((x, y, z) => {
                                    if (searchFailCallback)
                                        searchFailCallback(i18n.t('CIVICS.COMMON.AUTO_COMPLETE_DELEGATE_ERROR'));
                                });
                        }
                    });
                } else {//no delegates found
                    if (options && options.selectedCallback) {
                        //pass a null to indicate no response from delegate... since one wasn't used.
                        options.selectedCallback(null, acListItem);
                    }
                }
            });
            input.$input.on('autocomplete:updatesettings', function () {
                let autocompletePlugin = $(this).data('autocomplete');
                let updatedLayerList = $(this).data('layerList');
                if (autocompletePlugin && autocompletePlugin.settings && updatedLayerList) {
                    compositeDisplaySettings = $(this).data('autocomplete').settings.compositeDisplaySettings;
                    if (compositeDisplaySettings) {
                        compositeDisplaySettings.layerList = updatedLayerList;
                    }
                };
            });
            input.$input.off('unselecting').on('unselecting', (e, term, lastListItem, settings) => {
                if (lastListItem && lastListItem.model) {
                    delete lastListItem.model[settings.property];//make sure we don't reset the current auto complete field
                    var m = new IpsModel();

                    resetObject(lastListItem.model);
                    m.set(lastListItem.model);
                    ViewBindingManager.bindView(input.container, m);
                }
            });
        }

        return {
            Build: function (view) {
                var mdService = new AutoCompleteMDModel();
                mdService.moniker = compMoniker;
                mdService.fetch().done((jMdResponse, b, c) => {
                    if (jMdResponse.length > 0) {
                        var containers = !_.isArray(view) ? [view] : view;
                        var inputList = [];
                        if (inputNameAttr)
                            inputList = findInputs(containers, inputNameAttr);

                        _.forEach(jMdResponse, md => {
                            var settings = buildAutoCompleteSettings(md);
                            // If there is no inputNameAttr in the options, use the md.property
                            if (!inputNameAttr && md.property)
                                inputList = findInputs(containers, md.property);

                            // Attach Autocomplete Events and Settings to each $input
                            _.forEach(inputList, input => {
                                attachInputEventHandlers(input);
                                // Attach AutoCompleteSettings
                                input.$input.civicsautocomplete(settings);
                            });
                        });
                    }
                })
            }
        }
    }

    return _autoComplete;
});